/**
 * User videos: Shopify file = muted 10s preview; YouTube = thumb + muted iframe preview.
 * Modal close: pause YouTube previews and show thumb again (no stray audio).
 */
(function () {
  var PREVIEW_SECONDS = 10;
  var activePreviewStop = null;
  var openModalIds = new Set();

  function playMedia(el) {
    if (el && typeof el.play === 'function') {
      el.play();
    }
  }

  function pauseMedia(el) {
    if (el && typeof el.pause === 'function') {
      el.pause();
    }
  }

  function forcePreviewMuted(video) {
    if (!video || video.closest('[data-modal-player]')) {
      return;
    }
    try {
      video.muted = true;
      video.defaultMuted = true;
      video.volume = 0;
      video.setAttribute('muted', 'muted');
    } catch (e) {}
  }

  function bindPreviewMuteGuards(video) {
    if (!video || video.dataset.previewMuteBound === '1') {
      return;
    }
    video.dataset.previewMuteBound = '1';
    forcePreviewMuted(video);
    ['play', 'playing', 'volumechange', 'loadedmetadata', 'canplay', 'loadeddata', 'seeked'].forEach(function (evt) {
      video.addEventListener(
        evt,
        function () {
          forcePreviewMuted(video);
        },
        true
      );
    });
  }

  function getYoutubePreviewSrc(iframe) {
    if (!iframe) {
      return '';
    }
    if (!iframe.getAttribute('data-youtube-preview-src')) {
      iframe.setAttribute('data-youtube-preview-src', iframe.getAttribute('src') || iframe.src || '');
    }
    return iframe.getAttribute('data-youtube-preview-src') || '';
  }

  function postYoutubeCommand(iframe, func, args) {
    if (!iframe || !iframe.contentWindow) {
      return;
    }
    iframe.contentWindow.postMessage(
      JSON.stringify({ event: 'command', func: func, args: args === undefined ? '' : args }),
      '*'
    );
  }

  function muteYoutubeIframe(iframe) {
    postYoutubeCommand(iframe, 'mute');
    postYoutubeCommand(iframe, 'setVolume', [0]);
  }

  function pauseYoutubeIframe(iframe) {
    postYoutubeCommand(iframe, 'pauseVideo');
    muteYoutubeIframe(iframe);
  }

  function showYoutubeThumb(previewRoot) {
    if (!previewRoot) {
      return;
    }
    previewRoot.classList.remove('is-yt-playing');
    var thumb = previewRoot.querySelector('.product-user-videos__youtube-thumb');
    if (thumb) {
      thumb.style.opacity = '1';
      thumb.style.visibility = 'visible';
    }
  }

  function hideYoutubeThumb(previewRoot) {
    if (!previewRoot) {
      return;
    }
    previewRoot.classList.add('is-yt-playing');
    var thumb = previewRoot.querySelector('.product-user-videos__youtube-thumb');
    if (thumb) {
      thumb.style.opacity = '0';
      thumb.style.visibility = 'hidden';
    }
  }

  function waitForYoutubeIframe(clipEl, callback) {
    var tries = 0;
    var timer = setInterval(function () {
      var iframe = clipEl.querySelector('iframe[data-youtube-preview]');
      tries += 1;
      if (iframe && iframe.src && iframe.src.indexOf('youtube') !== -1) {
        clearInterval(timer);
        callback(iframe);
      } else if (tries > 60) {
        clearInterval(timer);
      }
    }, 150);
  }

  function bindYoutubeMuteLoop(iframe, getTimerRef, setTimerRef) {
    getYoutubePreviewSrc(iframe);
    muteYoutubeIframe(iframe);
    var existing = getTimerRef();
    if (existing) {
      clearInterval(existing);
    }
    setTimerRef(
      setInterval(function () {
        if (openModalIds.size === 0 && iframe.src && iframe.src.indexOf('youtube') !== -1) {
          muteYoutubeIframe(iframe);
        }
      }, 1500)
    );
  }

  function startYoutubePreview(previewRoot, clipEl, youtubeMuteTimerRef) {
    hideYoutubeThumb(previewRoot);
    playMedia(clipEl);
    waitForYoutubeIframe(clipEl, function (iframe) {
      bindYoutubeMuteLoop(
        iframe,
        function () {
          return youtubeMuteTimerRef.timer;
        },
        function (t) {
          youtubeMuteTimerRef.timer = t;
        }
      );
      postYoutubeCommand(iframe, 'seekTo', [0, true]);
      window.setTimeout(function () {
        muteYoutubeIframe(iframe);
      }, 500);
    });
  }

  function softStopYoutubePreview(previewRoot, clipEl) {
    showYoutubeThumb(previewRoot);
    var iframe = clipEl.querySelector('iframe[data-youtube-preview]');
    if (iframe) {
      pauseYoutubeIframe(iframe);
    }
    pauseMedia(clipEl);
  }

  function hardStopYoutubePreview(previewRoot, clipEl) {
    softStopYoutubePreview(previewRoot, clipEl);
    var iframe = clipEl.querySelector('iframe[data-youtube-preview]');
    if (iframe) {
      pauseYoutubeIframe(iframe);
    }
  }

  function waitForPreviewVideo(clipEl, callback) {
    var tries = 0;
    var timer = setInterval(function () {
      var video = clipEl.querySelector('video');
      tries += 1;
      if (video) {
        clearInterval(timer);
        callback(video);
      } else if (tries > 40) {
        clearInterval(timer);
      }
    }, 100);
  }

  function bindPreviewClip(previewRoot) {
    var clipEl = previewRoot.querySelector('[data-preview-clip]');
    if (!clipEl) {
      return;
    }

    var htmlVideo = null;
    var vimeoTimer = null;
    var youtubeMuteTimerRef = { timer: null };
    var isYoutube = !!previewRoot.querySelector('.product-user-videos__youtube-thumb');

    function resetVimeoPreview() {
      var iframe = clipEl.querySelector('iframe[data-vimeo-preview]');
      if (!iframe || !iframe.contentWindow) {
        return;
      }
      iframe.contentWindow.postMessage(JSON.stringify({ method: 'setCurrentTime', value: 0 }), '*');
      iframe.contentWindow.postMessage(JSON.stringify({ method: 'setVolume', value: 0 }), '*');
      iframe.contentWindow.postMessage(JSON.stringify({ method: 'play' }), '*');
    }

    function startPreview() {
      if (openModalIds.size > 0) {
        return;
      }
      if (activePreviewStop && activePreviewStop.previewRoot !== previewRoot) {
        activePreviewStop.stop();
      }

      if (clipEl.tagName === 'NATIVE-VIDEO') {
        playMedia(clipEl);
        waitForPreviewVideo(clipEl, function (video) {
          htmlVideo = video;
          bindPreviewMuteGuards(htmlVideo);
          forcePreviewMuted(htmlVideo);
          htmlVideo.loop = false;
          htmlVideo.controls = false;
          htmlVideo.removeAttribute('controls');
          if (htmlVideo.currentTime > PREVIEW_SECONDS) {
            htmlVideo.currentTime = 0;
          }
          htmlVideo.play().catch(function () {});
        });
      } else if (isYoutube) {
        startYoutubePreview(previewRoot, clipEl, youtubeMuteTimerRef);
      } else if (clipEl.tagName === 'EXTERNAL-VIDEO') {
        playMedia(clipEl);
        clearInterval(vimeoTimer);
        vimeoTimer = setInterval(resetVimeoPreview, PREVIEW_SECONDS * 1000);
      }
    }

    function stopPreview() {
      if (htmlVideo) {
        htmlVideo.pause();
        htmlVideo.currentTime = 0;
        forcePreviewMuted(htmlVideo);
      }
      if (isYoutube) {
        softStopYoutubePreview(previewRoot, clipEl);
      } else {
        pauseMedia(clipEl);
      }
      clearInterval(vimeoTimer);
      if (youtubeMuteTimerRef.timer) {
        clearInterval(youtubeMuteTimerRef.timer);
        youtubeMuteTimerRef.timer = null;
      }
      vimeoTimer = null;
      if (activePreviewStop && activePreviewStop.previewRoot === previewRoot) {
        activePreviewStop = null;
      }
    }

    if (clipEl.tagName === 'NATIVE-VIDEO') {
      clipEl.addEventListener(
        'timeupdate',
        function () {
          if (!htmlVideo) {
            htmlVideo = clipEl.querySelector('video');
            if (htmlVideo) {
              bindPreviewMuteGuards(htmlVideo);
            }
          }
          if (!htmlVideo) {
            return;
          }
          forcePreviewMuted(htmlVideo);
          if (htmlVideo.currentTime >= PREVIEW_SECONDS) {
            htmlVideo.currentTime = 0;
          }
        },
        true
      );
    }

    if (isYoutube) {
      showYoutubeThumb(previewRoot);
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && openModalIds.size === 0) {
            startPreview();
          } else {
            stopPreview();
          }
        });
      },
      { threshold: 0.25, rootMargin: '40px' }
    );

    observer.observe(previewRoot);

    if (openModalIds.size === 0) {
      var rect = previewRoot.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        startPreview();
      }
    }

    activePreviewStop = { previewRoot: previewRoot, stop: stopPreview };
  }

  function hardStopAllYoutubePreviews() {
    document.querySelectorAll('[data-user-video-preview]').forEach(function (preview) {
      var clip = preview.querySelector('[data-preview-clip]');
      if (preview.querySelector('.product-user-videos__youtube-thumb') && clip) {
        hardStopYoutubePreview(preview, clip);
      }
    });
  }

  function pauseAllPreviews() {
    document.querySelectorAll('[data-user-video-preview]').forEach(function (preview) {
      var clip = preview.querySelector('[data-preview-clip]');
      preview.querySelectorAll('video').forEach(function (video) {
        video.pause();
        forcePreviewMuted(video);
      });
      if (preview.querySelector('.product-user-videos__youtube-thumb') && clip) {
        hardStopYoutubePreview(preview, clip);
      } else if (clip) {
        pauseMedia(clip);
      }
    });
    if (activePreviewStop) {
      activePreviewStop.stop();
    }
  }

  function openModal(modal, button) {
    if (!modal) {
      return;
    }
    pauseAllPreviews();
    hardStopAllYoutubePreviews();
    modal.open = true;
    openModalIds.add(modal.id);
    if (button) {
      button.setAttribute('aria-expanded', 'true');
    }
    initModalPlayer(modal);
  }

  function onModalClosed(modal) {
    stopModalPlayer(modal);
    hardStopAllYoutubePreviews();
    openModalIds.delete(modal.id);
    document.querySelectorAll('.product-user-videos__open[aria-controls="' + modal.id + '"]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
    window.setTimeout(function () {
      if (openModalIds.size > 0) {
        return;
      }
      document.querySelectorAll('[data-user-video-preview]').forEach(function (preview) {
        var rect = preview.getBoundingClientRect();
        var inView = rect.top < window.innerHeight && rect.bottom > 0 && rect.width > 0;
        if (!inView) {
          return;
        }
        var clip = preview.querySelector('[data-preview-clip]');
        if (preview.querySelector('.product-user-videos__youtube-thumb') && clip) {
          var ref = { timer: null };
          startYoutubePreview(preview, clip, ref);
        }
      });
    }, 400);
  }

  function closeModal(modal) {
    if (!modal) {
      return;
    }
    modal.open = false;
    onModalClosed(modal);
  }

  function initModalPlayer(modal) {
    modal.querySelectorAll('[data-modal-player]').forEach(function (el) {
      playMedia(el);
      var video = el.querySelector('video');
      if (video) {
        video.removeAttribute('muted');
        video.muted = false;
        video.volume = 1;
        video.controls = true;
        video.loop = false;
        video.play().catch(function () {});
      }
    });
  }

  function stopModalPlayer(modal) {
    modal.querySelectorAll('[data-modal-player]').forEach(function (el) {
      pauseMedia(el);
      var video = el.querySelector('video');
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
      el.querySelectorAll('iframe').forEach(function (iframe) {
        try {
          postYoutubeCommand(iframe, 'pauseVideo');
          postYoutubeCommand(iframe, 'stopVideo');
        } catch (e) {}
      });
    });
  }

  function bindOpenButtons() {
    document.querySelectorAll('.product-user-videos__open').forEach(function (button) {
      if (button.dataset.userVideoBound === '1') {
        return;
      }
      button.dataset.userVideoBound = '1';
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        openModal(document.getElementById(button.getAttribute('aria-controls')), button);
      });
    });
  }

  document.querySelectorAll('[data-user-video-preview]').forEach(bindPreviewClip);
  bindOpenButtons();
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-user-video-preview]').forEach(bindPreviewClip);
    bindOpenButtons();
  });

  document.addEventListener('modal:attribute:changed', function (event) {
    var modal = event.target;
    if (!modal || !modal.classList || !modal.classList.contains('product-user-videos-modal')) {
      return;
    }
    if (modal.hasAttribute('open')) {
      if (!openModalIds.has(modal.id)) {
        openModalIds.add(modal.id);
        pauseAllPreviews();
        hardStopAllYoutubePreviews();
        initModalPlayer(modal);
      }
    } else if (openModalIds.has(modal.id)) {
      onModalClosed(modal);
    }
  });

  document.querySelectorAll('.product-user-videos-modal').forEach(function (modal) {
    var wasOpen = modal.hasAttribute('open');
    new MutationObserver(function () {
      var isOpen = modal.hasAttribute('open');
      if (isOpen && !wasOpen) {
        wasOpen = true;
        if (!openModalIds.has(modal.id)) {
          openModalIds.add(modal.id);
          pauseAllPreviews();
          hardStopAllYoutubePreviews();
          initModalPlayer(modal);
        }
      } else if (!isOpen && wasOpen) {
        wasOpen = false;
        if (openModalIds.has(modal.id)) {
          onModalClosed(modal);
        }
      }
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });
  });

  document.addEventListener('click', function (event) {
    var modal = event.target.closest('.product-user-videos-modal');
    if (modal && event.target.closest('[data-action="close"]')) {
      closeModal(modal);
    }
  });
})();